import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FilterCriteria } from '../../app/chargepoints-page/chargepoints-page.component';

export interface ChargepointsSearchDialogData {
  searchFormGroup: FormGroup;
  advancedFilterOptions: {
    id: string;
    name: string;
    description: string;
    criteria: FilterCriteria | null;
  }[];
}

@Component({
  selector: 'app-chargepoints-search-dialog',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    MatIconModule,
  ],
  templateUrl: './chargepoints-search-dialog.component.html',
  styleUrls: ['./chargepoints-search-dialog.component.scss'],
})
export class ChargepointsSearchDialogComponent {
  constructor(
    private readonly dialogRef: MatDialogRef<ChargepointsSearchDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public readonly data: ChargepointsSearchDialogData
  ) {}

  close(): void {
    this.dialogRef.close();
  }
}
